import { LogLevelEnum } from '../../enums/log-level/log-level.enum';
import { LOG_LEVEL } from './log-level.token';

export const provideLogger = (logLevel: LogLevelEnum) => ({
    provide: LOG_LEVEL,
    useValue: logLevel,
});
